'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reselect = require('reselect');

var _PopupPanelMouseManager = require('./PopupPanelMouseManager');

var _PopupPanelMouseManager2 = _interopRequireDefault(_PopupPanelMouseManager);

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _popupActions = require('./popupActions');

var _popupConstants = require('./popupConstants');

require('./PopupPanel.scss');

require('./PopupPanel.tooltip.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupPanel = function PopupPanel(props) {
    var visible = props.visible,
        className = props.className,
        arrowDir = props.arrowDir,
        children = props.children;

    if (!visible) return null;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('PopupPanel', className, 'arrow-' + (arrowDir || _popupConstants.ARROW_DIR.top)) },
        _react2.default.createElement(
            _PopupPanelMouseManager2.default,
            props,
            _react2.default.createElement(
                'div',
                { className: 'popup-content' },
                children
            )
        )
    );
};

var TransitionedPopupPanel = function TransitionedPopupPanel(props) {
    return _react2.default.createElement(
        _CSSTransitionGroup2.default,
        {
            transitionName: 'fade',
            transitionAppear: true,
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300,
            transitionAppearTimeout: 300 },
        props.visible ? _react2.default.createElement(PopupPanel, _extends({}, props, { visible: true })) : null
    );
};

PopupPanel.propTypes = TransitionedPopupPanel.propTypes = {
    visible: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    arrowDir: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};

var popupSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return state.getIn(['app', 'popup', 'active']);
}, function (state, ownProps) {
    return ownProps.popupId;
}, _gridSizeSelector.isMobileSize, function (popupState, popupId, isMobile) {
    return {
        visible: popupState.has(popupId),
        isMobile: isMobile
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        closePopup: function closePopup() {
            return dispatch((0, _popupActions.closePopup)(ownProps.popupId, false));
        }
    };
};

var enhance = (0, _reactRedux.connect)(popupSelector, mapDispatchToProps);

var PopupPanelContainer = function PopupPanelContainer(props) {
    return props.fadeIn ? _react2.default.createElement(TransitionedPopupPanel, props) : _react2.default.createElement(PopupPanel, props);
};

PopupPanelContainer.propTypes = {
    popupId: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    arrowDir: _propTypes2.default.string,
    arrowPos: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
    visible: _propTypes2.default.bool,
    closePopups: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    fadeIn: _propTypes2.default.bool,
    duration: _propTypes2.default.number,
    isMobileView: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    stayOpen: _propTypes2.default.bool
};

exports.default = enhance(PopupPanelContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/PopupPanel.js
// module id = 54
// module chunks = 0